import React, { useState, useEffect } from "react";
import "./Existing_Form.css";
import cancel from "../../../assets/cancel.png";
import Loader from "../../Loader/Loader";
import { toast } from "react-hot-toast";
import api from "../../../utils/api";

const Student_Form = (props) => {
  const [details, setDetails] = useState({
    class: "",
    email: "",
    father_email: "",
    father_name: "",
    father_phone: "",
    gr: "",
    grade: "",
    id: 0,
    mother_email: "",
    mother_name: "",
    mother_phone: "",
    name: "",
    password: "",
    section: "",
    status: "",
  });
  const [loading, setLoading] = useState(0);

  const isEdit = props.isEdit;
  const data = props.data;

  const handleClick2 = () => {
    props.setDisp();
    props.setEdit();
  };

  const [considering, setConsidering] = useState([]);

  useEffect(() => {
    setDetails(data);
  }, [isEdit]);

  const handleChange = (e) => {
    setDetails({
      ...details,
      [e.target.name]: e.target.value,
    });
    console.log(details);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(1);

    try {
      await api.put("/existingstudent", details);
      props.setDisp();
      props.onSuccess();
      toast.success("Student updated successfully");
      setLoading(0);
    } catch (error) {
      console.error("Error updating student details:", error);
      toast.error("Failed to update student");
      setLoading(0);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="circular__form_div_open">
        <div className="circular__form circular_edit">
          <div className="circular__form_header">
            <h1>Edit Student</h1>
            <div className="circular__from_img" onClick={handleClick2}>
              <img src={cancel} alt="cancel" />
            </div>
          </div>
          <div className="form_row">
            <div className="circular__form_input">
              <h5>GR Number</h5>
              <input
                required
                type="text"
                name="gr"
                readOnly
                disabled
                defaultValue={data.gr.substring(1)}
                className="circular__form_input_small"
              />
            </div>
            <div className="circular__form_input">
              <h5>Name</h5>
              <input
                required
                type="text"
                name="name"
                onChange={handleChange}
                defaultValue={data.name}
                className="circular__form_input_small"
              />
            </div>
          </div>
          <div className="form_row">
            <div className="circular__form_input">
              <h5>Class</h5>
              <input
                required
                type="text"
                name="class"
                onChange={handleChange}
                disabled
                defaultValue={data.class}
                className="circular__form_input_small"
              />
            </div>
            <div className="circular__form_input">
              <h5>Section</h5>
              <input
                required
                type="text"
                name="section"
                onChange={handleChange}
                disabled
                defaultValue={data.section}
                className="circular__form_input_small"
              />
            </div>
          </div>
          <div className="form_row">
            <div className="circular__form_input">
              <h5>Mother Name</h5>
              <input
                required
                type="text"
                name="mother_name"
                onChange={handleChange}
                defaultValue={data.mother_name}
                className="circular__form_input_small"
              />
            </div>
            <div className="circular__form_input">
              <h5>Father Name</h5>
              <input
                required
                type="text"
                name="father_name"
                onChange={handleChange}
                defaultValue={data.father_name}
                className="circular__form_input_small"
              />
            </div>
          </div>
          <div className="form_row">
            <div className="circular__form_input">
              <h5>Surname</h5>
              <input
                required
                type="text"
                name="surname"
                onChange={handleChange}
                defaultValue={data.surname}
                className="circular__form_input_small"
              />
            </div>
            <div className="circular__form_input">
              <h5>Mother E-mail</h5>
              <input
                required
                type="text"
                name="mother_email"
                onChange={handleChange}
                defaultValue={data.mother_email}
                className="circular__form_input_small"
              />
            </div>
          </div>
          <div className="form_row">
            <div className="circular__form_input">
              <h5>Mother’s phone</h5>
              <input
                required
                type="text"
                name="mother_phone"
                onChange={handleChange}
                defaultValue={data.mother_phone}
                className="circular__form_input_small"
              />
            </div>
            <div className="circular__form_input">
              <h5>Father E-mail</h5>
              <input
                required
                type="text"
                name="father_email"
                onChange={handleChange}
                defaultValue={data.father_email}
                className="circular__form_input_small"
              />
            </div>
          </div>
          <div className="form_row">
            <div className="circular__form_input">
              <h5>Father’s phone</h5>
              <input
                required
                type="text"
                name="father_phone"
                onChange={handleChange}
                defaultValue={data.father_phone}
                className="circular__form_input_small"
              />
            </div>
            <div className="circular__form_input">
              <h5>Phone</h5>
              <input
                required
                type="text"
                name="phone"
                onChange={handleChange}
                defaultValue={data.phone}
                className="circular__form_input_small"
              />
            </div>
          </div>
          <div className="form_row">
            <div className="circular__form_input">
              <h5>Date of Birth</h5>
              <input
                type="date"
                className="date"
                name="dob"
                onChange={handleChange}
                required
                defaultValue={
                  isEdit ? new Date(data.dob).toLocaleDateString("en-CA") : null
                }
              />
            </div>
            <div className="circular__form_input">
              <h5>Date of Admission</h5>
              <input
                type="date"
                className="date"
                name="date_of_admission"
                onChange={handleChange}
                required
                defaultValue={
                  isEdit
                    ? new Date(data.date_of_admission).toLocaleDateString("en-CA")
                    : null
                }
              />
            </div>
          </div>
          <div>
            {loading ? (
              <p style={{ color: "#fff" }}>
                <Loader small={true} />
              </p>
            ) : (
              <button className="circular__form_button" type="submit">
                <span style={{ color: "#fff" }}>Edit Student</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </form>
  );
};

export default Student_Form;